import {Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';
import {BehaviorSubject, Subscription, timer} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private readonly loading = new BehaviorSubject<LoaderOptions>({isLoading: false});
  private thresholdSubscribtion: Subscription;
  private timerSubscribtion: Subscription;
  private readonly defaultThresholdTime = 500;

  constructor(private readonly injector: Injector) {
  }

  private get router(): Router {
    return this.injector.get(Router);
  }

  get isLoading(): LoaderOptions {
    return this.loading.getValue();
  }

  set isLoading(flag: LoaderOptions) {

    this.thresholdSubscribtion?.unsubscribe();
    this.timerSubscribtion?.unsubscribe();

    if (!flag.isLoading) {
      this.loading.next({isLoading: false});
      return;
    }

    const timerValue = flag.threshold ? flag.threshold : this.defaultThresholdTime;
    const thresholdTimer = timer(flag.immediate ? 0 : timerValue);
    this.thresholdSubscribtion = thresholdTimer.subscribe(() => {
      this.loading.next({isLoading: true});
    });
    if (flag.timeout) {
      this.timerSubscribtion = timer(flag.timeout.value).subscribe(() => {
        if (flag.timeout.errorPath && flag.timeout.errorStatus) {
          this.router.navigate([flag.timeout.errorPath, flag.timeout.errorStatus]);
        }
        if (flag.timeout.timeoutFunction) {
          flag.timeout.timeoutFunction();
        }
      });
    }

  }
}

export class LoaderOptions {
  isLoading;
  immediate?;
  threshold?;
  timeout?: {
    value;
    errorPath?;
    errorStatus?;
    timeoutFunction?;
  };
}
